export default __webpack_public_path__ + "static/media/brownback.0389e873.png";